import { render, staticRenderFns } from "./CardLabel.vue?vue&type=template&id=3b7519ee&scoped=true&"
import script from "./CardLabel.vue?vue&type=script&lang=js&"
export * from "./CardLabel.vue?vue&type=script&lang=js&"
import style0 from "./CardLabel.vue?vue&type=style&index=0&id=3b7519ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7519ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
